<template>
    <div class="form-group" v-bind:class="{'dark': this.getDesign() == 'black', 'white' : this.getDesign() == 'white'}">
        <input type="text" :placeholder="$t(this.field.name)" v-model="value" :required="field.isRequired" @change="changeInput">
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';

    export default {
        name: "input-normal-direction",
        props: ["field"],
        data() {
            return {
                value: '',
            }
        },
        computed: {
            ...mapGetters(['getDesign','getCheckout'])
        },
        created() {
            this.value = this.getCheckout().direction;
            this.changeInput();
        },
        methods: {
            ...mapMutations(['updateCheckoutField']),
            changeInput: function () {

                this.updateCheckoutField({name: 'direction', value: this.value});

                if(this.getCheckout().id) {
                    this.$emit('change-field');
                }
            }
        }
    }
</script>
